import { useGtm } from '@gtm-support/vue-gtm'

class ContentModule {
  contentView (urlPathAndParams: string, contentViewName: string = ''): void {
    const gtm = useGtm()
    if (!gtm?.enabled()) {
      return
    }

    const eventData = {
      event: 'content-view',
      'content-name': urlPathAndParams,
      'content-view-name': contentViewName
    }

    gtm.trackEvent(eventData)
  }
}

export default ContentModule
